import React, { useEffect, useState } from "react";
import {
  downloadPaymentFile,
  getBlock,
  getDistrict,
  getGPbyBlock,
  reject_vendor_payment,
  vendor_payment_data,
  dscSignature,
  registryEntry,
  dscChecker,
  validateDSC,
  approveVenderPayment,
  sendOTP,
  ProcessTransaction,
  getVendorDetail,
  getVendorPaymentPageCount,
} from "../../api/User";
import loader from "../../images/ajax-loader.gif";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { Box, Typography, Button, IconButton } from "@mui/material";
import dscImg from "../../images/dscImg.png";
import CloseIcon from "@mui/icons-material/Close";
import "../../index.css";
import { ToastContainer, toast } from "react-toastify";
import DSCValidationPage from "../DSCValidation";
import { Modal, Container, Form, Button } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import { FiArrowLeftCircle } from "react-icons/fi";
import { FiArrowRightCircle } from "react-icons/fi";

// import dsc from "../images/dsc.png";

function VendorPaymentRelease({ token, userDetail, userData }) {
  const [showTable, setShowTable] = useState(true);
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPType, setGPType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [toReject, setToReject] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(true);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [isResendVisible, setIsResendVisible] = useState(false);
  const [isSubmitVisible, setIsSubmitVisible] = useState(true); // Submit button visible initially

  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [GpName, setGpName] = useState("");
  const MySwal = withReactContent(Swal);
  const [modal, setModal] = useState(false);
  const [proceedButton, setProceedButton] = useState(false);
  const [OTPmodal, setOTPModal] = useState(false);
  const [OTPerr, setOTPErr] = useState("");
  const [numErr, setNumErr] = useState("");
  const [numValue, setNumValue] = useState("");
  const [otpInput, setOtpInput] = useState(false);
  const [registryData, setRegistryData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [DSCModalShow, setDSCModalShow] = useState(false);
  const [isBlinking, setIsBlinking] = useState(true);
  const [showProceedButton, setShowProceedButton] = useState(false);
  const [sanctionId, setSanctionId] = useState("");
  const [OTP, setOTP] = useState("");
  const [makerName, setMakerName] = useState("");
  const [tokenNew, setTokenNew] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [quarter, setQuarter] = useState("");
  const [isApproved, setIsApproved] = useState(false);
  const [showNumberInput, setShowNumberInput] = useState(true);
  const [timeLeft, setTimeLeft] = useState(180);
  const [pageVal, setPageVal] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState("");
  const [pdfname,setPdfName]= useState("");

  const goToPreviousPage = () => {
    if (pageVal > 1) {
      setPageVal(pageVal - 1);
      const newPage = pageVal - 1;
      getVendorpaymentDetails(newPage);
    }
  };

  const goToNextPage = () => {
    if (pageVal < totalPageCount) {
      setPageVal(pageVal + 1);
      const newPage = pageVal + 1;
      getVendorpaymentDetails(newPage);
    }
  };

  const role = userDetail?.role_id;
  const id = userDetail?.user_id;
  const ckeckerName = userData?.data?.user_firstname;
  console.log(userDetail?.user_id);

  useEffect(() => {
    if (timeLeft <= 0) return; // Stop the timer when timeLeft is 0 or below
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount or reset
  }, [timeLeft]);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reloaded = urlParams.get("reloaded");

    if (!reloaded) {
      urlParams.set("reloaded", "true");
      window.history.replaceState(null, "", "?" + urlParams.toString());
      window.location.reload();
    }

    const options = [];
    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonly(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonly(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonly(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonly(false);
    }
    // getVendorpaymentDetails(token);
    setVisibleOptions(options);
  }, [role, GPType]);

  const getVendorpaymentDetails = (newPage) => {
    setLoading(true);

    const data = {
      district_code: districtType,
      block_code: blockType,
      village_code: GPType,
      role_id: userDetail.role_id,
      page: newPage,
    };
    getVendorPaymentPageCount(token, data).then((res) => {
      setTotalPageCount(res.data);
      vendor_payment_data(token, data)
        .then((res) => {
          if (res.status === "success") {
            setTableData(res.data);
          } else {
            console.error("Failed to get payment details:", res.error);
          }
        })
        .catch((err) => {
          console.error("Error fetching payment details:", err);
        });
      setTimeout(() => {
        // setShowTable(true);
        setLoading(false);
      }, 1000);
    });
  };

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);
      if (res.data.length == 1) {
        setDistrictType(res.data[0].district_code);
        setDistrictName(res.data[0].district_name);
        fetchBlockData(res.data[0].district_code);
      } else {
        setDistrictType(res.data.district_code);
        setDistrictName(res.data.district_name);
        fetchBlockData(res.data.district_code);
      }
      if (role == 11) {
        const data = {
          district_code: res.data[0].district_code,
          block_code: blockType,
          village_code: GPType,
          role_id: userDetail.role_id,
          page: pageVal,
        };
        getVendorPaymentPageCount(token, data).then((res) => {
          setTotalPageCount(res.data);
          vendor_payment_data(token, data)
            .then((res) => {
              if (res.status === "success") {
                setTableData(res.data);
              } else {
                console.error("Failed to get payment details:", res.error);
              }
            })
            .catch((err) => {
              console.error("Error fetching payment details:", err);
            });
        });
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);

      if (res.user.length == 1) {
        setBlockType(res.user[0].block_code);
        setBlockName(res.user[0].block_name);
        fetchVillageData(res.user[0].block_code, data.district);
      }
      if (role == 9) {
        const data = {
          district_code: districtCode,
          block_code: res.user[0].block_code,
          village_code: GPType,
          role_id: userDetail.role_id,
          page: pageVal,
        };
        getVendorPaymentPageCount(token, data).then((res) => {
          setTotalPageCount(res.data);
          vendor_payment_data(token, data)
            .then((res) => {
              if (res.status === "success") {
                setTableData(res.data);
              } else {
                console.error("Failed to get payment details:", res.error);
              }
            })
            .catch((err) => {
              console.error("Error fetching payment details:", err);
            });
        });
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    setLoadingBlock(true);
    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };
    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);
          setIsReadonly(true);
          setGPType(res.data[0].VillageId);
          if (role == 7) {
            const data = {
              district_code: district_code,
              block_code: blockcode,
              village_code: res.data[0].VillageId,
              role_id: userDetail.role_id,
              page: pageVal,
            };
            getVendorPaymentPageCount(token, data).then((res) => {
              setTotalPageCount(res.data);
              vendor_payment_data(token, data)
                .then((res) => {
                  if (res.status === "success") {
                    setTableData(res.data);
                  } else {
                    console.error("Failed to get payment details:", res.error);
                  }
                })
                .catch((err) => {
                  console.error("Error fetching payment details:", err);
                });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    } finally {
      setLoadingBlock(false);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;

    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setDistrictType(e.target.value);
    const data = {
      role: role,
      id: id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    setBlockType(e.target.value);
    const data = {
      role_id: role,
      id: id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleGPChange = (e) => {
    setGPType(e.target.value);
    e.preventDefault();
    setLoading(true);

    const data = {
      district_code: districtType,
      block_code: blockType,
      village_code: e.target.value,
      role_id: userDetail.role_id,
      page: pageVal,
    };
    vendor_payment_data(token, data)
      .then((res) => {
        if (res.status === "success") {
          setTableData(res.data);
        } else {
          console.error("Failed to get payment details:", res.error);
        }
      })
      .catch((err) => {
        console.error("Error fetching payment details:", err);
      });
    setTimeout(() => {
      setShowTable(true);
      setLoading(false);
    }, 1000);
  };

  const handleReject = async (res) => {
    const data = {
      sanction_id: res.sanction_id,
      fy: res.fy,
      quarter: res.quarter,
      payment: res.payment,
      district_code: districtType,
      block_code: blockType,
      village_code: GPType,
    };
    try {
      await reject_vendor_payment(token, data)
        .then((res) => {
          if (res.status === "success") {
            setLoading(true);

            const data = {
              district_code: districtType,
              block_code: blockType,
              village_code: GPType,
              role_id: userDetail.role_id,
              page: pageVal,
            };
            getVendorPaymentPageCount(token, data).then((res) => {
              setTotalPageCount(res.data);
              vendor_payment_data(token, data)
                .then((res) => {
                  if (res.status === "success") {
                    setTableData(res.data);
                  } else {
                    console.error("Failed to get payment details:", res.error);
                  }
                })
                .catch((err) => {
                  console.error("Error fetching payment details:", err);
                });

              setTimeout(() => {
                setShowTable(true);
                setLoading(false);
              }, 1000);
            });
          } else {
            console.error("Failed to reject vendor payment");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log("Error fetching data : ", error);
    }
    setToReject([]);
  };

  const handleView = async (val) => {
    // const data = {
    //   sanction_id: val.sanction_id,
    //   maker: val.maker,
    // };
    // try {
    //   const response = await downloadPaymentFile(token, data);
    //   if (response.status === 200) {
    //     const url = window.URL.createObjectURL(
    //       new Blob([response.data], { type: "application/pdf" })
    //     );
    //     const a = document.createElement("a");
    //     a.style.display = "none";
    //     a.href = url;
    //     a.download = "payment_file.pdf";
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //     document.body.removeChild(a);
    //   } else {
    //     console.error("Failed to view vendor payment");
    //   }
    // } catch (error) {
    //   console.log("Error fetching data: ", error);
    // }
    val.checker_approval == 0
      ? window.open(
          `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${val.maker_signed_file_name}.pdf`,
          "_blank"
        )
      : window.open(
          `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${val.maker_signed_file_name}_checker_signed.pdf`,
          "_blank"
        );
  };

  const ApprovalStatement = (role) => {
    if (role === 7) {
      return "I Sarpanch had reviewed & signed the payment file to be approved for bank processing .";
    }
    if (role === 9) {
      return "I Chairman-PS  had reviewed & signed the payment file to be approved for bank processing.";
    }
    if (role === 11) {
      return "I President-ZP  had reviewed & signed the payment file to be approved for bank processing.";
    }
  };
  const RejectStatement = (role) => {
    if (role === 7) {
      return "I Sarpanch  had reviewed & signed the payment file to be rejected for bank processing.";
    }
    if (role === 9) {
      return "I Chairman-PS had reviewed & signed the payment file to be rejected for bank processing .";
    }
    if (role === 11) {
      return "I President-ZP  had reviewed & signed the payment file to be rejected for bank processing.";
    }
  };
  const openOTPmodal = () => {
    setOTPModal(true);
  };
  const closeOTPmodal = () => {
    setOTPModal(false);
    setOtpInput(false);
  };
  const closeModal = () => {
    setModal(false);
    setProceedButton(false);
    setOtpInput(false);
    setDSCModalShow(false);
  };
  const none = () => {};
  const validDSC = async () => {
    setLoadingNew(true);
    fetch(
      `http://127.0.0.1:9196/isDscPresent/${userData?.data?.user_firstname}`,
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          MySwal.fire({
            icon: "warning",
            title: "Invalid DSC",
            text: "DSC Not Inserted!",
          });
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((data) => {
        console.log("data1", data);
        if (data == "DSC is valid") {
          fetch(
            `http://127.0.0.1:9196/dscauth/${userData?.data?.user_firstname}`,
            {
              method: "GET",
            }
          )
            .then((res) => {
              if (!res.ok) {
                MySwal.fire({
                  icon: "warning",
                  title: "Invalid DSC",
                  text: "DSC Not Valid!",
                });
                throw new Error(`HTTP error! status: ${res.status}`);
              }
              return res.text();
            })
            .then((data2) => {
              if (data2 == "DSC is valid") {
                setShowProceedButton(true);
                setLoadingNew(false);
                MySwal.fire({
                  icon: "success",
                  title: "DSC Validated",
                  text: "DSC Validated Successfully!",
                  customClass: {
                    popup: "custom-swal-popup",
                  },
                });
              } else {
                setLoadingNew(false);
                MySwal.fire({
                  icon: "warning",
                  title: "Invalid DSC",
                  text: "Please attach valid DSC.",
                  customClass: {
                    popup: "custom-swal-popup",
                  },
                });
              }
            })
            .catch((error) => {
              setLoadingNew(false);
              console.error("Error:", error);
              MySwal.fire({
                icon: "error",
                title: "Error",
                text:
                  error.message === "Failed to upload voucher"
                    ? "Failed to upload voucher."
                    : "Please Start Java Utility",
              });
            });
        } else {
          setLoadingNew(false);
          MySwal.fire({
            icon: "warning",
            title: "Invalid DSC",
            text: "Please attach valid DSC.",
          });
        }
      })
      .catch((error) => {
        setLoadingNew(false);
        MySwal.fire({
          icon: "warning",
          title: "Invalid DSC",
          text: "Please attach valid DSC.",
        });
        console.error("Error:", error);
      });
  };
  const validateDsc = async (e) => {
    setLoadingNew(true);
    openOTPmodal();
    setLoadingNew(false);
  };

  const handleOTP = (e) => {
    const { value } = e.target;
    const offPinRegex = /^[0-9]{6}$/;
    if (value === "" && offPinRegex) {
      setOTPErr("This field is required.");
    } else if (offPinRegex.test(value)) {
      console.log(value);
      setOTP(value);
      setOTPErr("");
    } else {
      setOTPErr("OTP must be of 6 Digits.");
    }
  };
  const handleNumber = (e) => {
    const { value } = e.target;
    const offPinRegex = /^[0-9]{10}$/;
    if (value === "" && offPinRegex) {
      setNumErr("This field is required.");
    } else if (offPinRegex.test(value)) {
      setNumValue(value);
      setNumErr("");
    } else {
      setNumErr("Number must be of 10 digits");
    }
  };
  const checkNumber = async () => {
    console.log(userData?.data?.user_mobile_no);
    if (numValue == userData?.data?.user_mobile_no) {
      const data = {
        phone_number: userData?.data?.user_mobile_no,
      };

      await sendOTP(token, data).then((res) => {
        if (res.status == "success") {
          setTimeLeft(180);
          setOtpInput(true);
          console.log(res.token);
          setTokenNew(res.token);
        }
      });
    } else {
      setNumErr("Number Doesn't Match");
      setOtpInput(false);
    }
  };

  useEffect(() => {
    if (otpInput) {
      const timeoutId = setTimeout(() => {
        setIsSubmitVisible(false);
        setIsResendVisible(true);
      }, 180000);

      return () => clearTimeout(timeoutId);
    }
  }, [otpInput]);

  const resendOTP = async () => {
    setTimeLeft(180);
    setOTPErr("");
    setIsSubmitVisible(true);
    setIsResendVisible(false);
    if (numValue == userData?.data?.user_mobile_no) {
      const data = {
        phone_number: userData?.data?.user_mobile_no,
      };

      await sendOTP(token, data).then((res) => {
        if (res.status == "success") {
          setOtpInput(true);
          console.log(res.token);
          setTokenNew(res.token);
        }
      });
    } else {
      setNumErr("Number Doesn't Match");
      setOtpInput(false);
    }
  };
  const getRegistryEntity = async (e) => {
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
    };
    try {
      const res = await registryEntry(token, data);
      if (res.status == "success") {
        setRegistryData(res.data);
      } else {
        console.log("Error Occured");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMakerFileName = (e, id,data) => {
    setPdfName(data.maker_signed_file_name)
    setDSCModalShow(true);
    setSanctionId(id);
    setFileName(e.target.value);
    getRegistryEntity();
  };

  const handleDSCClose = () => {
    setDSCModalShow(false);
  };
  const handleProceedButton = async () => {
    handleProceed();
  };

  const handleDSCOpen = () => {
    setDSCModalShow(true);
  };
  const handleProceed = async () => {
    setShowProceedButton(false);
    await setLoadingNew(true);
    fetch(`http://localhost:9196/signPdf/1/12345678/${fileName}/checker`)
      .then((data) => {
        return data.text();
      })
      .then((res) => {
        if (res.indexOf("maker_signed_checker_signed") !== -1) {
          const approvalData = {
            sanction_id: sanctionId,
          };
          approveVenderPayment(token, approvalData).then((resp) => {
            // setLoadingNew(true);
            if (resp.status == "success") {
              const data = {
                district_code: districtType,
                block_code: blockType,
                village_code: GPType,
                role_id: userDetail.role_id,
                page: pageVal,
              };
              getVendorPaymentPageCount(token, data).then((res) => {
                setTotalPageCount(res.data);
                vendor_payment_data(token, data)
                  .then((res) => {
                    if (res.status === "success") {
                      setLoadingNew(false);
                      MySwal.fire({
                        icon: resp.status,
                        title: resp.message,
                      }).then(() => {
                        window.open(
                          `https://sfc-account-module.s3.ap-south-1.amazonaws.com/uploads/${pdfname}_checker_signed.pdf`,
                          "_blank"
                        );
                      });;
                      setTableData(res.data);
                      setLoading(false);
                    } else {
                      setLoadingNew(false);
                      MySwal.fire({
                        icon: res.status,
                        title: res.message,
                      });
                      console.error(
                        "Failed to get payment details:",
                        res.error
                      );
                    }
                  })
                  .catch((err) => {
                    setLoadingNew(false);
                    console.error("Error fetching payment details:", err);
                  });
              });
            }
          });
        }
      })
      .catch((err) => console.log(err));

      // setLoadingNew(false);
      // console.error("Error uploading voucher:", err);
      // MySwal.fire({
      //   icon: "warning",
      //   title: "Error Signing the PDF",
      // });
      // setLoading(false);
  };
  const handleSanctionId = (id, name, vId, qua) => {
    setQuarter(qua);
    setSanctionId(id);
    setVendorId(vId);
    setMakerName(name);
    console.log(id);
  };

  const handleOTPSubmit = async () => {
    const data = {
      user_id: userDetail?.user_id,
      userotp: OTP,
      district_code: districtType,
      block_code: blockType,
      village_code: GPType,
      sanction_id: sanctionId,
      role: role,
      vendor_id: vendorId,
      quarter: quarter,
    };
  
    await ProcessTransaction(tokenNew, data).then((res) => {
      MySwal.fire({
        icon: res.status,
        title: res.status,
        text: res.message,
        customClass: {
          popup: "swal2-custom-popup",
        },
      });
  
      if (res.status === "Success") {
        const data2 = {
          district_code: districtType,
          block_code: blockType,
          village_code: GPType,
          role_id: userDetail?.role_id,
          page: pageVal,
        };
        const data3 = {
          user_id: userDetail?.user_id,
          district_code: districtType,
          block_code: blockType,
          village_code: GPType,
          sanction_id: sanctionId,
          role_id: role,
          vendor_id: vendorId,
        };
  
        getVendorPaymentPageCount(token, data3).then((res) => {
          setTotalPageCount(res.data);
          vendor_payment_data(token, data2)
            .then((res) => {
              if (res.status === "success") {
                setLoadingNew(false);
                setTableData(res.data);
                setLoading(false);
              } else {
                setLoadingNew(false);
                MySwal.fire({
                  icon: res.status,
                  title: res.message,
                });
                console.error("Failed to get payment details:", res.error);
              }
            })
            .catch((err) => {
              setLoadingNew(false);
              console.error("Error fetching payment details:", err);
            });
        });
  
        
        closeOTPmodal();
      } else {
        
        setOTPErr("Invalid OTP, please try again.");
      }
    }).catch((error) => {
      console.error("Error processing transaction:", error);
      setOTPErr("An error occurred. Please try again.");
    });
  };
  

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div
        id="loading-coupon2"
        style={{ display: loadingNew ? "flex" : "none" }}
      >
        <img id="loading-image2" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid col px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5>
            <strong>Vendor Payment Release</strong>
          </h5>
        </div>
        <form className="filter" id="myform">
          <div className="row mb-4">
            <div className="col-4">
              <label htmlFor="type" className="form-label">
                Entity {<span style={{ color: "red" }}>*</span>}{" "}
              </label>
              <select
                name="type"
                id="type"
                className="type form-select"
                value={selectedValue}
                onChange={handleEntityChange}
                disabled={isReadonly}
              >
                <option value="" disabled>
                  Select Type
                </option>
                {visibleOptions.includes("sab") && (
                  <option value="sab">All</option>
                )}
                {visibleOptions.includes("gp") && (
                  <option value="gp">Gram Panchayat</option>
                )}
                {visibleOptions.includes("ps") && (
                  <option value="ps">Panchayat Samiti</option>
                )}
                {visibleOptions.includes("zp") && (
                  <option value="zp">Zila Parishad</option>
                )}
                {visibleOptions.includes("zp") && (
                  <option value="zp">District</option>
                )}
              </select>
            </div>
          </div>
          <div className="row d-flex">
            <div style={{ width: "33.33%" }}>
              <label className="form-label">
                District  {<span style={{ color: "red" }}>*</span>}
              </label>
              {role == 6 ||
              role == 7 ||
              role == 8 ||
              role == 9 ||
              role == 11 ||
              districtData.length == 1 ? (
                <input
                  className="form-control"
                  type="text"
                  value={districtData[0]?.district_name}
                  disabled={isReadonly}
                  onInput={handleDistrictChange}
                />
              ) : (
                <select
                  name="district"
                  className="common-input form-select"
                  required
                  value={districtType}
                  onChange={handleDistrictChange}
                >
                  <option value="">Select District</option>
                  {districtData?.map((district, index) => (
                    <option key={index} value={district.district_code}>
                      {district.district_name}
                    </option>
                  ))}
                </select>
              )}
            </div>
            {role == 7 || role == 9 ? (
              <div className style={{ width: "33.33%" }}>
                <label className="form-label">
                  Block {<span style={{ color: "red" }}>*</span>}
                </label>
                {role == 6 ||
                role == 7 ||
                role == 8 ||
                role == 9 ||
                blockData.length == 1 ? (
                  <input
                    name="block"
                    className="form-control"
                    type="text"
                    value={blockData[0]?.block_name}
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="block"
                    className="common-input form-select"
                    value={blockType}
                    required
                    onChange={handleBlockChange}
                  >
                    <option value="">Select Block</option>
                    {blockData?.map((block, index) => (
                      <option key={index} value={block.block_code}>
                        {block.block_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            ) : (
              ""
            )}
            {role == 7 ||role == 6 ? (
              <div className style={{ width: "33.33%" }}>
                <label className="form-label">
                  Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                </label>
                {GPData?.length == 1 ? (
                  <input
                    name="GP"
                    className="form-control"
                    type="text"
                    value={
                      GPData && GPData.length > 0 ? GPData[0].VillageName : ""
                    }
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="district"
                    className="common-input form-select"
                    defaultValue={GpName}
                    onChange={handleGPChange}
                    required
                  >
                    <option value="">Select Gram Panchayat</option>
                    {GPData?.map((gp, index) => (
                      <option key={index} value={gp.VillageId}>
                        {gp.VillageName}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </form>
        <div className="">
          <div className="mb-4 mt-4 col-12 d-flex justify-content-start align-items-center">
            <h5 className="">Release To Bank</h5>
          </div>

          <div style={{ overflowX: "auto" }} className="mb-5">
            <table
              className="table table-striped table-bordered justify-content-center align-items-center"
              aria-label="simple table"
            >
              <thead>
                <tr style={{ fontSize: "16px" }}>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    S. No.
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Payment amount
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Purpose of Work
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Vendor Name
                  </th>
                  <th
                    align="center"
                    style={{
                      width: "5rem",
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Year
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Quarter
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    File Created At
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    File Created By
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    View File
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Approve
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Reject File
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Send File to Bank
                  </th>
                </tr>
              </thead>
              {showTable && (
                <tbody>
                  {!tableData || tableData.length === 0 ? (
                    <tr style={{ fontSize: "16px", color: "grey" }}>
                      <td colSpan="13" style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  ) : (
                    tableData?.map((data, index) => (
                      <tr key={index} style={{ fontSize: "16px" }}>
                        <td component="th">{index + 1}</td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.payment}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.narration}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.vendor_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.fy}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.quarter}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data?.created
                            ?.replace("T", " ")
                            .replace(".000Z", "")}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.first_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <button
                            align="center"
                            type="submit"
                            className="btn w-70"
                            onClick={() => handleView(data)}
                            style={{
                              backgroundColor: "#fda72c",
                              color: "white",
                            }}
                          >
                            View
                          </button>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <button
                            align="center"
                            type="submit"
                            className="btn w-70"
                            disabled={data.checker_approval == 0 ? false : true}
                            value={data.maker_signed_file_name}
                            onClick={(e) =>
                              handleMakerFileName(e, data.sanction_id,data)
                            }
                            style={{
                              backgroundColor:
                                data.checker_approval == 0 ? "green" : "grey",
                              color: "white",
                            }}
                          >
                            {data.checker_approval == 0
                              ? "Approve"
                              : "Approved"}
                          </button>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <button
                            align="center"
                            type="submit"
                            className="btn w-70"
                            data-bs-toggle="modal"
                            data-bs-target="#reject"
                            disabled={data.checker_approval == 0 ? false : true}
                            onClick={() => setToReject(data)}
                            style={{
                              backgroundColor:
                                data.checker_approval == 0 ? "red" : "grey",
                              color: "white",
                            }}
                          >
                            {data.is_reject != null || data.is_reject != 0
                              ? "Reject"
                              : "Rejected"}
                          </button>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <button
                            align="center"
                            type="submit"
                            className="btn w-70 ms-3"
                            disabled={
                              data.checker_approval == 0
                                ? true
                                : data.send_to_bank == 1
                                ? true
                                : false
                            }
                            onClick={
                              data.send_to_bank == 0 ? validateDsc : none
                            }
                            onMouseEnter={() =>
                              handleSanctionId(
                                data.sanction_id,
                                data.first_name,
                                data.vendor_id,
                                data.quarter
                              )
                            }
                          >
                            {data.send_to_bank == 0
                              ? "Send to Bank"
                              : "Sent to bank"}
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <div className="px-5 pb-4 d-flex">
            <div
              onClick={goToPreviousPage}
              disabled={pageVal === 1}
              className={` flex ${
                pageVal === 1 ? "bg-gray-200 " : "bg-blue-500 text-blue"
              }`}
              style={{ cursor: pageVal === 1 ? "not-allowed" : "pointer" }}
            >
              <FiArrowLeftCircle size={"2rem"} />
            </div>

            {pageVal > 1 && (
              <span
                onClick={() => setPageVal(pageVal - 1)}
                className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
                style={{ fontSize: "13px" }}
              >
                {pageVal - 1}
              </span>
            )}

            <span
              className="px-3 py-0 rounded-md bg-blue-500 font-bold"
              style={{ fontSize: "18px" }}
            >
              {pageVal}
            </span>

            {pageVal < totalPageCount && (
              <span
                onClick={() => setPageVal(pageVal + 1)}
                className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
              >
                {pageVal + 1}
              </span>
            )}

            <div
              onClick={goToNextPage}
              disabled={pageVal === totalPageCount}
              className={`${
                pageVal === totalPageCount
                  ? "bg-gray-200"
                  : "bg-blue-500 text-gray"
              }`}
              style={{
                cursor: pageVal === totalPageCount ? "not-allowed" : "pointer",
              }}
            >
              <FiArrowRightCircle size={"2rem"} />{" "}
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="reject"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content ">
              <div className="modal-header bg-body-tertiary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Payment Creation
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body bg-body-tertiary">
                <div className="m-2">
                  <span>{RejectStatement(role)}</span>
                </div>
              </div>
              <div className="modal-footer bg-body-tertiary">
                <button
                  type="button"
                  className="btn"
                  data-bs-dismiss="modal"
                  onClick={() => handleReject(toReject)}
                >
                  Yes
                </button>
                <button type="button" className="btn" data-bs-dismiss="modal">
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={OTPmodal}
          onHide={closeOTPmodal}
          centered
          size="lg"
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Modal.Header closeButton>
            <Modal.Title>OTP Verification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="d-flex justify-content-center my-5">
                {/* Number Input Form */}
                {!otpInput && (
                  <div className="col-8 mx-4">
                    <Form.Group controlId="number" className="mb-2">
                      <Form.Label>Enter Your Number</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={10}
                        className={numErr ? "is-invalid" : ""}
                        onChange={handleNumber}
                        style={{ height: "40px" }}
                      />
                      {numErr && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {numErr}
                        </p>
                      )}
                    </Form.Group>
                    <Button
                      variant="primary"
                      onClick={checkNumber}
                      style={{ width: "100%" }}
                    >
                      Check
                    </Button>
                  </div>
                )}

                {/* OTP Input Form */}
                {otpInput && (
                  <div className="col-8 mx-4">
                    <Form.Group controlId="otp" className="mb-2">
                      <Form.Label>Enter the 6-digit OTP</Form.Label>
                      <Form.Control
                        type="text"
                        maxLength={6}
                        className={OTPerr ? "is-invalid" : ""}
                        onChange={handleOTP}
                        style={{ height: "40px" }}
                      />
                      {OTPerr && (
                        <p style={{ color: "red", fontSize: "10px" }}>
                          {OTPerr}
                        </p>
                      )}
                    </Form.Group>
                    <p>Your OTP is valid for 3 minutes</p>
                    <p
                      className={`mt-3 ${timeLeft > 0 ? "disabled" : ""}`}
                      onClick={timeLeft === 0 ? resendOTP : null}
                      style={{
                        cursor: timeLeft > 0 ? "not-allowed" : "pointer",
                        pointerEvents: timeLeft > 0 ? "none" : "auto",
                      }}
                    >
                      <span className="text-danger">Resend</span> OTP in{" "}
                      {timeLeft} {timeLeft === 1 ? "second" : "seconds"}
                    </p>
                    <div className="d-flex justify-content-between">
                      {isSubmitVisible && (
                        <Button
                          variant="primary"
                          onClick={handleOTPSubmit}
                          style={{ width: "100%" }}
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal show={DSCModalShow} onHide={handleDSCClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>DSC validation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <DSCValidationPage
                Type={"VenderPaymentRelease"}
                close={handleDSCClose}
                userData={userData}
                token={token}
                userDetail={userDetail}
                loadingFunction={handleProceedButton}
              />
            </Container>
          </Modal.Body>
        </Modal>

        <ToastContainer />
      </div>
    </>
  );
}

export default VendorPaymentRelease;
